export { MarketingConfigurationModule } from "./MarketingConfigurationModule";
